import React from "react";
import Aos from "aos";
import "aos/dist/aos.css";



function CustomCarpetServices() {
  return (
    <div className="comp-list-home">
    </div>
  );
}

export default CustomCarpetServices;
